import { render } from "./CustomerReview_0.vue?vue&type=template&id=95d8a384"
import script from "./CustomerReview_0.vue?vue&type=script&lang=js"
export * from "./CustomerReview_0.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__